(function () {
    'use strict';

    if (!window.greenmotion.showCookieConsent) {
        return;
    }

    window.cookieconsent_options = {
        message: gmtrans('shared.cookie_consent.message'),
        theme: 'light-floating',
        learnMore: gmtrans('shared.cookie_consent.learn_more_link'),
        dismiss: gmtrans('shared.cookie_consent.dismiss_button'),
        link: '/cookies',
    };

    require('cookieconsent');
})();
